import axios from "axios";
import configs from "../../../app/configurations/configs";

const IP = configs.SERVER_IP;

const state = {
  locations:[],
  error:{},
  response:{}
};

const getters = {
  getLocations: (state) => state.locations,
  getLocationSuccessResponse: (state) => state.response,
  getLocationErrorResponse: (state) => state.error,
};

const actions = {
  async fetchLocations({ commit }) {
    await axios
      .get(IP + "/locations/business/"+localStorage.getItem("business_id"))
      .then((response) => {
        commit("setLocationSuccessResponse", response.data);
      })
      .catch((error) => {
        commit("setLocationErrorResponse", error.response);
      });
  },
  async createLocation({ commit }, data) {
    await axios
        .post(IP + "/locations", data)
        .then((response) => {
          commit("setLocationResponse", response.data);
        })
        .catch((error) => {
          commit("setLocationErrorResponse", error.response);
        });
  },
  async editLocation({ commit }, data) {
    await axios
        .put(IP + "/locations/"+data.id, data.form)
        .then((response) => {
          commit("setLocationResponse", response.data);
        })
        .catch((error) => {
          commit("setLocationErrorResponse", error.response);
        });
  },
};

const mutations = {
  setLocationSuccessResponse: (state, response) => {
    state.locations = response.data;
  },
  setLocationResponse: (state, response) => {
    state.response = response.data;
  },
  setLocationErrorResponse: (state, response) => {
    state.error = response.data;
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
